import { useState } from "react";
import styled from "styled-components";

import { FixaListView } from "../../../shared/wrappers/FixaListView/FixaListView";

import type { RefillAreas } from "../../types/departments";

import useFixaNavigate from "@coworker/apprestructured/src/shared/wrappers/FixaNavigate/useFixaNavigate";
import { RefillAreaListItem } from "./RefillAreaListItem";
import FixaSearch from "../../../shared/wrappers/FixaSearch/FixaSearch";
import { useTranslation } from "@coworker/locales";

export const FixaListViewWithBackground = styled(FixaListView)`
  background: var(--white);
`;

const SearchWrapper = styled.div`
  padding: 16px 24px;
  border-bottom: 8px solid var(--grey100);
`;

const RefillAreasList = ({ refillAreas }: { refillAreas: RefillAreas }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useFixaNavigate();
  const { t } = useTranslation();

  return (
    <FixaListViewWithBackground id="refill-area-list">
      <SearchWrapper>
        <FixaSearch
          id="search-refill-area"
          placeholder={t("searchRefillAreaString")}
          onChange={(e) => setSearchQuery(e.target.value)}
          onClear={() => setSearchQuery("")}
        />
      </SearchWrapper>
      {refillAreas.map((refillArea, index) => (
        <RefillAreaListItem
          key={`${index}`}
          refillArea={refillArea}
          onClick={() =>
            navigate(`/multi-order-addons/refill-area/${refillArea.area}`)
          }
          searchQuery={searchQuery}
        />
      ))}
    </FixaListViewWithBackground>
  );
};

export default RefillAreasList;
